module.exports = __webpack_public_path__ + "img/img9.80ba0308.svg";